import { PreferencesContext } from "../../contexts/PreferencesContext";
import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';
import { logout } from '../../actions/AppActions';
import { connect } from 'react-redux';
import SweetAlert from 'react-bootstrap-sweetalert';

// unidades
import moment from 'moment';
import { URL } from '../../variables';
import {
  MdAdd,
  MdApartment,
  MdCalendarToday,
  MdDelete,
  MdDescription,
  MdModeEdit,
  MdPersonOutline,
  MdSort
} from 'react-icons/md';
import { Pagination } from '@material-ui/lab';
import { CircularProgress } from '@material-ui/core';
import Search from '../ReusableComponents/Search';
import { BsFillEyeFill, BsGraphUp } from "react-icons/bs";
import { Button } from "react-bootstrap";
import './label.css';


class Faculdades extends Component {
  static contextType = PreferencesContext;

  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      path: '/',
      loading_screen: false,
      faculdades: [],
      pagination: {
        page: 1,
        last_page: 1
      },
      msgErro: '',
      show_warning: false,
      show_erro: false,
      unidade_to_delete: '',
      search: '',
      sort: 'recent',
      loading_search: true
    };
  }






  componentDidMount() {

    this.get_faculdades(this.state.pagination.page);
  }

  get_faculdades(page, search = '', busca = true, sort = this.state.sort) {
    if (busca == true) {
      if (this.state.loading_search == false) {
        this.setState({ loading_search: true });
      }
    } else
      if (this.state.loading_screen === false) {
        this.setState({ loading_screen: true });
      }
    fetch(`${URL}api/faculdade/get_faculdades?page=${page}&search=${search}&sort=${sort}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Authorization': `Bearer ${this.props.token}`
        // 'Content-Type': 'application/json',
      }
    }).then(async (responseLog) => {
      try {
        let resp = await responseLog.json();
        console.log(resp);
        if (resp.message == "Unauthenticated.") {
          localStorage.removeItem('token'); localStorage.removeItem('user');
          this.props.logout();
          return;
        }
        if (resp.errors != null || resp.error != null) {
          let errors = Object.values(resp.errors);
          let erro = '';
          for (let i = 0; i < errors.length; i++) {
            if (i != errors.length - 1)
              erro += errors[i] + '\n'; else

              erro += errors[i];
          }
          console.log(erro);
          this.setState({ redirect: true });
        } else {
          this.setState({ loading_search: false, faculdades: resp.faculdades, loading_screen: false, pagination: resp.pagination });
        }
      } catch (err) {
        this.setState({ redirect: true });
        console.log(err);
      }

    }).
      catch((err) => {
        this.setState({ redirect: true });

        console.log(err);
        // this.props.mudarLoadingHome(false);
      });
  }


  delete_faculdade(id) {

    fetch(`${URL}api/faculdade/delete_faculdade/${id}`, {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        'Authorization': `Bearer ${this.props.token}`
        // 'Content-Type': 'application/json',
      }
    }).then(async (responseLog) => {
      try {
        let resp = await responseLog.json();
        console.log(resp);
        if (resp.message == "Unauthenticated.") {
          localStorage.removeItem('token'); localStorage.removeItem('user');
          // this.setState({redirect:true,path:'/'});
          this.props.logout();
          return;
        }
        if (resp.errors != null || resp.error != null) {
          let errors = Object.values(resp.errors);
          let erro = '';
          for (let i = 0; i < errors.length; i++) {
            if (i != errors.length - 1)
              erro += errors[i] + '\n'; else

              erro += errors[i];
          }
          console.log(erro);
          this.setState({ msgErro: erro, show_warning: false, show_erro: true });
        } else {
          this.setState({ show_warning: false });
          this.get_faculdades(this.state.pagination.page, this.state.search);
        }




      } catch (err) {
        this.setState({ redirect: true });
        console.log(err);


      }

    }).
      catch((err) => {
        this.setState({ redirect: true });

        console.log(err);
      });
  }







  getEntityContent() {
    const isInstitution = this.props.user.empresa == null || this.props.user.empresa.change_text == false;

    return {
      isInstitution,
      title: isInstitution ? this.context.t("title_institution") : this.context.t("title_process"),
      plural: isInstitution ? this.context.t("organizations") : this.context.t("processes"),
      singular: isInstitution ? this.context.t("organization") : this.context.t("process"),
      add: isInstitution ? this.context.t("action_new_institution") : this.context.t("action_new_process"),
      subtitle: isInstitution ? this.context.t("description_manage_institutions") : this.context.t("description_manage_processes"),
      emptyTitle: isInstitution ? this.context.t("empty_no_institutions_registered") : this.context.t("empty_no_processes_registered"),
      emptyDescription: isInstitution ? this.context.t("empty_register_first_institution") : this.context.t("empty_register_first_process"),
      searchLabel: isInstitution ? this.context.t("legacy_da_instituicao") : this.context.t("legacy_do_processo"),
      viewLabel: isInstitution ? this.context.t("action_view_institution") : this.context.t("action_view_process"),
      processCountLabel: isInstitution ? this.context.t("title_process") : this.context.t("legacy_vagas")
    };
  }

  getProcessCount(item) {
    const possibleCounts = [
      item.processes_count,
      item.processos_count,
      item.process_count,
      item.processo_count,
      item.processos_seletivos_count,
      item.processo_seletivos_count,
      item.vagas_count,
      item.total_processos,
      item.pages_count,
      Array.isArray(item.processos) ? item.processos.length : null,
      Array.isArray(item.processes) ? item.processes.length : null,
      Array.isArray(item.processos_seletivos) ? item.processos_seletivos.length : null,
      Array.isArray(item.processo_seletivos) ? item.processo_seletivos.length : null,
      Array.isArray(item.vagas) ? item.vagas.length : null
    ]
    .map((count) => Number(count))
    .filter((count) => !Number.isNaN(count));

    return possibleCounts.length > 0 ? Math.max(...possibleCounts) : 0;
  }

  getSortedFaculdades() {
    const list = [...this.state.faculdades];

    if (this.state.sort === 'name') {
      return list.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
    }

    return list.sort((a, b) => {
      const firstDate = new Date(a.created_at || 0).getTime();
      const secondDate = new Date(b.created_at || 0).getTime();
      return this.state.sort === 'oldest' ? firstDate - secondDate : secondDate - firstDate;
    });
  }

  render() {
    const entity = this.getEntityContent();
    const sortedFaculdades = this.getSortedFaculdades();
    const totalItems = this.state.pagination.total || this.state.pagination.total_pages || this.state.faculdades.length;
    const firstItem = totalItems > 0 ? ((this.state.pagination.current_page || 1) - 1) * (this.state.pagination.per_page || this.state.faculdades.length || 1) + 1 : 0;
    const lastItem = totalItems > 0 ? Math.min(firstItem + this.state.faculdades.length - 1, totalItems) : 0;
    const totalPages = this.state.pagination.last_page || 1;

    return (
      <div className="row">
        {this.state.redirect == true && <Redirect to={this.state.path} />}

        <div className="col-12">
          <div className="institutions-shell-card">
            <div className="card-body institutions-shell-body" id="card">



              <div className="row">

                <div className="col-12">


                  {/* <hr /> */}
                  {this.state.loading_screen == false && <div className="institutions-page">



                    <div className="institutions-summary-card">
                      <div className="page-header">
                        <div>
                          <h2 className="page-title">{entity.title}</h2>
                          <p className="page-subtitle">{entity.subtitle}</p>
                        </div>

                        {(this.props.user.role == 'region_admin' ||
                          this.props.user.empresa == null || this.props.user.empresa.can_add) &&

                          <Link
                            to="/instituicao/register"
                            style={{ textDecoration: 'none' }}>

                            <Button className="btn-add-modern">
                              <MdAdd />{entity.add}
                            </Button>
                          </Link>
                        }

                      </div>

                      <div className="stats-row">
                        <div className="stat-card">
                          <div className="stat-icon stat-icon-primary"><MdApartment /></div>
                          <div>
                            <h3>{totalItems}</h3>
                            <span>{entity.plural}</span>
                          </div>
                        </div>

                        <div className="stat-card">
                          <div className="stat-icon stat-icon-accent"><MdDescription /></div>
                          <div>
                            <h3>{totalPages}</h3>
                            <span>{this.context.t("legacy_paginas")}</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="institutions-list-card">
                      <div className="institutions-toolbar">
                        <div className="faculdades-search-field">
                          <Search
                            hide_class={true}
                            className="faculdades-search-input"
                            style={{ padding: 0 }}
                            placeholder={`${this.context.t("placeholder_search_by_name")} ${entity.searchLabel}`}
                            ValueChange={(value) => {

                              clearTimeout(this.pesquisarTimeout);

                              this.pesquisarTimeout = setTimeout(() => {

                                let page = { ...this.state.pagination };

                                page.current_page = 1;

                                this.setState({
                                  pagination: page,
                                  search: value,
                                  loading_search: true
                                });

                                this.get_faculdades(1, value);

                              }, 1000);

                            }} />
                        </div>

                        <label className="faculdades-sort-control">
                          <span><MdSort /> {this.context.t("label_sort_by")}</span>
                          <select
                            value={this.state.sort}
                            onChange={(event) => {
                              const sort = event.target.value;
                              let page = { ...this.state.pagination };
                              page.current_page = 1;
                              this.setState({ sort, pagination: page, loading_search: true });
                              this.get_faculdades(1, this.state.search, true, sort);
                            }}
                          >
                            <option value="recent">{this.context.t("sort_recent")}</option>
                            <option value="oldest">{this.context.t("sort_oldest")}</option>
                            <option value="name">{this.context.t("sort_name")}</option>
                          </select>
                        </label>
                      </div>

                      {this.state.loading_search === false &&

                        <div className="institutions-grid">

                          {sortedFaculdades.map((item) =>

                            <div
                              key={item.id}
                              className="institution-card">

                              <div className="institution-card-main">
                                <div className="institution-header">
                                  <div className="institution-avatar">
                                    {item.logo && <img style={{padding:0,background:'unset'}} src={item.logo} alt={item.name} onError={(event) => { event.currentTarget.style.display = 'none'; }} />}
                                    {/* <MdApartment className={item.logo ? "institution-avatar-fallback" : ""} /> */}
                                  </div>

                                  <div>
                                    <h5>{item.name}</h5>

                                    {this.props.user?.empresa?.online_proccess &&
                                      <small>/{item.slug}</small>
                                    }

                                  </div>
                                </div>

                                <div className="institution-info">
                                  <div className="info-row">
                                    <span><MdCalendarToday /> {this.context.t("label_created_at")}</span>
                                    <strong>
                                      {item.created_at ? moment(item.created_at).format('DD/MM/YYYY') : this.context.t("summary_not_informed")}
                                    </strong>
                                  </div>

                                  <div className="info-row">
                                    <span><MdPersonOutline /> {this.context.t("label_registered_by")}</span>
                                    <strong>{item.owner?.name || this.context.t("summary_not_informed")}</strong>
                                  </div>

                                  <div className="info-row">
                                    <span><MdDescription /> {entity.processCountLabel}</span>
                                    <strong>{item.processos}</strong>
                                  </div>
                                </div>
                              </div>

                              <div className="institution-actions">
                                {this.props.user?.empresa?.online_proccess == true &&

                                  <Link
                                    to={`/instituicao/dashboard/${item.id}`}>

                                    <button
                                      className="institution-icon-action institution-icon-action-dashboard"
                                      title={this.context.t("dashboard")}>

                                      <BsGraphUp />
                                    </button>
                                  </Link>

                                }

                                <Link
                                  to={`/instituicao/show/${item.id}`}>

                                  <button
                                    className="institution-icon-action institution-icon-action-view"
                                    title={entity.viewLabel}>

                                    <BsFillEyeFill />
                                  </button>
                                </Link>

                                {(this.props.user.role == 'region_admin' ||
                                  this.props.user.empresa == null ||
                                  this.props.user.empresa.can_edit) &&

                                  <Link
                                    to={`/instituicao/edit/${item.id}`}>

                                    <button
                                      className="institution-icon-action institution-icon-action-edit"
                                      title={this.context.t("edit")}>

                                      <MdModeEdit />
                                    </button>
                                  </Link>

                                }

                                {(this.props.user.role == 'region_admin' ||
                                  this.props.user.empresa == null ||
                                  this.props.user.empresa.can_exclude) &&

                                  <button
                                    className="institution-icon-action institution-icon-action-delete"
                                    title={this.context.t("action_delete")}
                                    onClick={() => {
                                      this.questao_id = item.id;

                                      this.setState({
                                        show_warning: true
                                      });
                                    }}>

                                    <MdDelete />
                                  </button>

                                }

                              </div>

                            </div>

                          )}

                        </div>

                      }

                      {this.state.loading_search &&

                        <div className="text-center mt-5">
                          <CircularProgress />
                        </div>

                      }

                      {!this.state.loading_search &&
                        this.state.faculdades.length === 0 &&

                        <div className="empty-state">

                          <h4>{entity.emptyTitle}</h4>

                          <p>{entity.emptyDescription}</p>

                        </div>

                      }

                      <Pagination
                        className={
                          this.state.pagination.last_page === 1 ?
                            "hide" :
                            ""
                        }
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          marginTop: 30
                        }}
                        count={this.state.pagination.last_page}
                        value={this.state.pagination.current_page}
                        onChange={(_, value) => {

                          let page = {
                            ...this.state.pagination
                          };

                          page.current_page = value;

                          this.setState({
                            pagination: page
                          });

                          this.get_faculdades(
                            value,
                            this.state.search,
                            true,
                            this.state.sort
                          );

                        }} />

                      {!this.state.loading_search && this.state.faculdades.length > 0 &&
                        <div className="institutions-results-summary">
                          {this.context.t("label_showing")} {firstItem} {this.context.t("label_to")} {lastItem} {this.context.t("label_of")} {totalItems} {entity.plural.toLowerCase()}
                        </div>
                      }
                    </div>


                  </div>}

                  {this.state.loading_screen == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center" style={{ marginTop: '2rem' }}>
                    {/* <div className="spinner-border text-primary" role="status"  >
                        </div> */}
                    <CircularProgress />
                  </div></div>}

                  <SweetAlert
                    warning
                    title={this.context.t("legacy_atencao")}
                    onConfirm={() => {
                      this.setState({ show_warning: false, loading_search: true });
                      this.delete_faculdade(this.questao_id);
                      // this.delete_banner(this.state.banner_to_delete);
                    }}
                    onCancel={() => {
                      this.setState({ show_warning: false });
                    }}
                    show={this.state.show_warning}
                    confirmBtnText={this.context.t("legacy_sim_desejo_apagar")}
                    cancelBtnText={this.context.t("legacy_cancelar")}
                    confirmBtnBsStyle="success"
                    cancelBtnBsStyle="danger"
                    showCancel={true}>{this.context.t("ui_ao_deletar_esta_faculdade_ela_nao_estara_mais_disp_09656d24")}


                  </SweetAlert>


                </div>

              </div>

            </div>

          </div>
        </div>
      </div>);

  }


}
const mapsStateToProps = (state) => (
  {
    user: state.AppReducer.user,
    token: state.AppReducer.token
  });


export default connect(mapsStateToProps, { logout })(Faculdades);
